module.exports = __webpack_public_path__ + "media/application/images/finger-print-a8639b54b8683e4fbca3bdaa8bf30d73.png";